// extracted by mini-css-extract-plugin
export var backdropBlur = "_lw-0";
export var contentCard = "_lw-5";
export var frame = "_lw-2";
export var image = "_lw-4";
export var imagePane = "_lw-3";
export var modal = "_lw-1";